import { render, staticRenderFns } from "./CheckQueryDetail.vue?vue&type=template&id=fc8d3cb6&scoped=true&"
import script from "./CheckQueryDetail.vue?vue&type=script&lang=js&"
export * from "./CheckQueryDetail.vue?vue&type=script&lang=js&"
import style0 from "./CheckQueryDetail.vue?vue&type=style&index=0&id=fc8d3cb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8d3cb6",
  null
  
)

export default component.exports